import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { v4 } from 'uuid';
import { ButtonComponent } from '../../forms/components/button/button.component';
import { Type } from '../../forms/components/button/types/button-type.type';
import { Size } from '../../forms/components/button/types/size.type';
import { Style } from '../../forms/components/button/types/style.type';
import { IconComponent } from '../icon/icon.component';
import { IconColor } from '../icon/types/icon-color.types';
import { PopoverComponent } from '../popover/popover.component';
import { TypoColor } from '../typo/types/color.type';
import { TypoName } from '../typo/types/name.type';
import { Weight } from '../typo/types/weight.enum';
import { TypoComponent } from '../typo/typo.component';
import { IDropDownAction } from './models/drop-down-action.model';

@Component({
    selector: 'berry-dropdown',
    standalone: true,
    imports: [CommonModule, NgbDropdownModule, ButtonComponent, IconComponent, TypoComponent, PopoverComponent, TranslateModule],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
    providers: [NgbModal],
})
export class DropdownComponent {

    @ViewChild('popover') popover !: PopoverComponent;
    @Input() id: string | number = v4();;

    @Input() buttonType: Type = 'secondary';
    @Input() buttonSize: Size = 'small';
    @Input() buttonStyle: Style = 'filled';
    @Input() buttonActionType: 'button' | 'reset' | 'submit' = 'submit';
    @Input() isFixedWidth: boolean = true;
    @Input() disabled: boolean = false;
    
    @Input() actions: IDropDownAction[] = [];
    @Input() text: string = "";
    @Input() typoName: TypoName = "t1";
    @Input() typoWeight: Weight = 400;
    @Input() icon!: string;
    @Input() leftIcon!: string;
    @Input() color: IconColor = 'primary';
    @Input() typoColor: Type | TypoColor = 'primary';
    @Input() secondaryColor: IconColor = 'secondary';
    @Input() data!: any;
    @Input() index!: number;
    @Input() className!: string;
    @Input() showResultText: boolean = false;
    @Input() showResultIcon: boolean = false;
    @Input() container: "body" | null = 'body';

    @Input() withBorder: boolean = true;

    @Input() showLastItemIndex: boolean = false;
    @Input() removeDots: boolean = false;

    @Output('onClose') onClose: EventEmitter<any> = new EventEmitter();
    @Input({ required: true}) dataAutomationId! : string;/////
    optionTextSelcted!: string;
    optionIconSelcted!: string;
    @Input() optionColorIconSelcted!: string;
    @Input() reversePlacement: boolean = false;

    value!: string;
    arrowControl : any = {}


    constructor() {

    }



    closePopup = (e: any) => {
        if (!e.srcElement.className.includes('dropdownMenuContainer')) {
            this.popover.close()
        }

    }
    getOptionSelctedText(text: string) {
        this.popover.close()
        if (!this.showResultText) return
        this.optionTextSelcted = this.data ? ' : ' + text : text
    }

    getOptionSelctedIcon(icon: any, color: any) {
        this.popover.close()
        if (!this.showResultText) return
        this.optionIconSelcted = icon;
        this.optionColorIconSelcted = color
    }

    public get label(): string {
        if (this.data && !this.optionTextSelcted)
            this.optionTextSelcted = (this.removeDots ? ' ' : ' : ') + this.data;

        let label = this.optionTextSelcted;
        if (this.text && !this.data) {
            label = this.text + (this.removeDots ? ' ' : ' : ') + label;
        }

        return this.text + ((this.showResultText && !!this.optionTextSelcted) ? label : '')
    }

    public get startIcon(): string {
        if (this.data && !this.optionIconSelcted)
            this.optionIconSelcted = this.data;

        if (this.showResultIcon && !!this.optionIconSelcted) {
            return this.optionIconSelcted
        } else {
            return this.icon;
        }
    }

    onStatusChange(menuStatus: boolean) {
        if (menuStatus) {
            window.addEventListener('scroll', this.closePopup, true);
        } else {
            window.removeEventListener('scroll', this.closePopup, true);

            this.onClose.emit()
        }

    }

}
